const details = {
    name: "فروشگاه ورنالند",
    enName: "shop",
    description: "فروشگاه ورنالند",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "راه اندازی سایت ورزشی",
        link: "https://barantm.com/landing/sports-website-design"
    }
}

export default details;
